import { render, staticRenderFns } from "./ed-deck-viewer-controls.component.vue?vue&type=template&id=3207c72a&scoped=true&"
import script from "./ed-deck-viewer-controls.component.ts?vue&type=script&lang=ts&"
export * from "./ed-deck-viewer-controls.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-deck-viewer-controls.component.scss?vue&type=style&index=0&id=3207c72a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3207c72a",
  null
  
)

export default component.exports